import styled from "styled-components";

export const PlacementsContainer = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
`;

export const PlacementsTitle = styled.span`
  color: var(--primary-dark-300);
  font-size: var(--fs-base);
  line-height: var(--lh-base);
  font-style: normal;
  font-weight: 400;
`;
